<template>
  <div class="the-hot">
    <div class="title">
      <div class="text">会话记录</div>
      <img src="@img/clean.png" alt="" srcset="" @click="clean">
    </div>
    <div>
        <el-button class="open-new-session" icon="el-icon-chat-dot-square" @click="onOpenNewSession">开启新对话</el-button>
    </div>
    <div class="list">
      <div class="session-history-item" v-for="(item, index) in sessionHistory" :key="index + item" >
        <template v-if="item.list.length">
          <div class="session-time">{{item.date | formatDateFiled}}</div>
          <div class="session-item item" v-for="(session) of item.list" :key="session.id" @click="onClick(session)">
            <img src="@img/clock.png">
            <span class="text" :title="session.chatMessages[1].content">{{ session.chatMessages[1].content }}</span>

            <div class="session-item__tools" @click.stop>
              <el-dropdown size="medium" trigger="click" placement="bottom-start">
              <span class="session-item__tool-icon">
                <i class="el-icon-more"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="session-item__del" @click.native="onDelSessionItem(session)"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-history",
  mixins: [],
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {},
  filters: {
    formatDateFiled (value) {
      const dist = {
        'today': '今天',
        'yesterday': '昨天',
        'last30day': '30天内',
        'out30day': '30天外'
      }
      return dist[value]
    }
  },
  computed: {
    sessionHistory () {

      var data = {
        'today': [],
        'yesterday': [],
        'last30day': [],
        'out30day': []
      };

      // 处理 list 数据结构, 区分今天，昨天，30天内，30天外
      this.list.forEach((item) => {
        if(this.isToday(item.timestamp)) {
          data.today.push(item)
        } else if(this.isYesterday(item.timestamp)) {
          data.yesterday.push(item)
        } else if(this.isLast30Day(item.timestamp)) {
          data.last30day.push(item)
        } else {
          data.out30day.push(item)
        }
      })

      // 排序，时间近的靠前
      var newList = [];
      for (let key in data) {
        newList.push({
          date: key,
          list: this.sortByTime(data[key])
        })
      }
      return newList
    },
  },
  data() {
    return {

    }
  },
  methods: {
    onOpenNewSession () {
      this.$emit('openNewSession')
    },
    sortByTime(list) {
      return list.sort((a, b) => {
        return a.timestamp - b.timestamp
      })
    },
    onDelSessionItem (session) {
      this.$emit('delSessionItem', session.id)
    },
    isToday(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()
    },
    isYesterday(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate() - 1
    },
    isLast30Day(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() >= now.getDate() - 30
    },
    onClick(item) {
      this.$emit('click', item)
    },
    clean() {
      this.$emit('clearClick')
    }
  },
  mounted() { }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.the-hot {
  padding: 20px 16px 0 16px;

  .title {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    img {
      transform: scale(1);
      transition: .2s ease-in-out;

      &:hover {
        transform: scale(1.2);
        transition: .2s ease-in-out;
      }
    }
  }

  .open-new-session {
    color: #4d6bfe;
    background: #dbeafe;
    border: none;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 12px;
    font-size: var(--font-size);
    padding: 10px 18px;
    &:hover {
      background: #c6dcf8;
    }
  }

  .list {
    min-height: 175px;
    height: calc(100vh - 465px);
    overflow-y: auto;

    .session-history-item {
      .session-time {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    .item {
      display: flex;
      align-items: center;
      opacity: 1;
      border-radius: 10px;
      background: rgba(189, 211, 255, 0.2);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 4px 10px;
      cursor: pointer;
      transition: .2s ease-in-out;

      img {
        margin-right: 10px;
      }

      .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(78, 85, 135, 1);
        font-size: var(--font-size);
      }

      &+.item {
        margin-top: 8px;
      }

      &:hover {
        transition: .2s ease-in-out;
        background: rgba(189, 211, 255, 0.8);
      }

      .session-item__tools {
        margin-left: auto;
        .session-item__tool-icon {
          display: inline-block;
          padding: 6px;
        }

      }
    }
  }
}

::v-deep .session-item__del {
  color: #e53535;
  &:hover {
    color: #e53535;
    background: rgba(184, 92, 92, 0.16);
  }
}

</style>
